import { QuizMachineContext } from '../../context'

export const usePersonalizedWayfinding = () => {
  const { showLogo, logoAnimationFinished, isPostLogoAnimationDelayFinished } =
    QuizMachineContext.useSelector((state) => {
      const states = {
        animating: state.matches('completeQuiz.animating'),
        animated: state.matches('completeQuiz.animated'),
        delayed: state.matches('completeQuiz.delayed'),
      }

      return {
        ...states,
        showLogo: states.animating || states.animated || states.delayed,
        logoAnimationFinished: states.animated || states.delayed,
        isPostLogoAnimationDelayFinished: states.delayed,
      }
    })

  return {
    showLogo,
    logoAnimationFinished,
    isPostLogoAnimationDelayFinished,
  }
}
